export class WebSocketService {
  constructor(userId, notificationStore) {
    this.userId = userId;
    this.notificationStore = notificationStore;
    this.channels = new Map();
  }

  initialize() {
    if (!window.Echo || !this.userId) {
      console.warn('Echo or userId not available');
      return;
    }

    // Set up notification channel
    this.subscribeToNotifications();

    // Could add other channels here
    this.subscribeToMessages();
  }

  subscribeToNotifications() {
    const channel = window.Echo.private(
      `App.Models.User.${this.userId}`
    ).notification(notification => {
      this.notificationStore.handleNewNotification(notification);
      console.log('WebSocket: Notification received', notification.message);
    });

    this.channels.set('notifications', channel);
  }

  subscribeToMessages() {
    const channel = window.Echo.private(`messenger.user.${this.userId}`).listen(
      '.new.message',
      e => {
        console.log('New message received:', e);
      }
    );

    this.channels.set('messages', channel);
  }

  disconnect() {
    this.channels.forEach((channel, name) => {
      console.log(`Disconnecting ${name} channel`);
      window.Echo.leave(channel);
    });
    this.channels.clear();
  }

  //  add more methods for different ubscription types
  subscribeToChannel(channelName, callback) {
    const channel = window.Echo.private(channelName).listen(
      '.new.event',
      callback
    );

    this.channels.set(channelName, channel);
  }
}
